import { tcpaShieldService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { SET_ACTION_STATUS_PENDING, SET_ACTION_STATUS_SUCCESS, SET_ACTION_STATUS_ERROR } from '@/store/helpers';

import {
  GET_TCPA_HISTORY,
  SET_TCPA_HISTORY_STATUS
} from './mutationTypes';

const actions = {
  async getTcpaHistory({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, {actionName: 'getTcpaHistory' });
    try {
      const response = await tcpaShieldService.getHistory(rootState.currentAccountId);
      commit(GET_TCPA_HISTORY, response.logs);
      commit(SET_ACTION_STATUS_SUCCESS, {actionName: 'getTcpaHistory' });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, {actionName: 'getTcpaHistory', error: e });
    }
  },
};

export default actions;